import { Component } from '@angular/core';

@Component({
  selector: 'app-ui-text',
  templateUrl: './ui-text.component.html',
  styleUrls: ['./ui-text.component.css']
})
export class UiTextComponent {
  /**
   * Header button list show
   */
  Settingicon = true;
  Menuoption = 'center'
}
